module.exports = __webpack_public_path__ + "img/manage-shoots.7b02d34f.svg";